import { Component, OnInit, Output, EventEmitter, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { UserLogin } from "../../models";
import { NgForm } from "@angular/forms";
import { Token } from "../../models/token";
import { UserAuthenticationService, CommonDataService } from "../../services/shared";
import {NgProgressService} from "ng2-progressbar";
import * as swal                from "sweetalert2";
import { CONFIGURATION } from "../../app.constants";
@Component({
    selector: "login-component",
    template: require("./login.component.html"),
    providers:[CommonDataService]
})

export class LoginComponent implements OnInit {
    @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
    userLogin: UserLogin;
    errorMessage: string;
    isProcessing: boolean;
    IsbannerMessageActive: boolean;
    bannerMessage: string;

    loginAttempts: number = 0;
    @ViewChild("loginForm") loginForm: NgForm;

    constructor(private userAuthService: UserAuthenticationService, private cecRouter: Router, 
                private pService: NgProgressService, protected commonDataService: CommonDataService) {
        
        window.location.href =  CONFIGURATION.baseUrls.cloudUi;
        this.userLogin = new UserLogin();
        this.userLogin.password = "";
        this.userLogin.userName ="";
        this.isProcessing = false;
        // this.GetBanner();
    }

    public ngOnInit() {
        // if (this.userAuthService.isAuthenticated) {
        //     this.cecRouter.navigate(["/myhome"]);
        // }
    }

    public DoUserLogin(): void {
        this.pService.start();
        this.isProcessing = true;
        this.handleProcessing.emit(true);
        this.errorMessage = "";
        this.userAuthService
            .Login(this.userLogin.userName, this.userLogin.password)
            .subscribe(
            (response: Token) => {
                this.cecRouter.navigate(["/myhome"]);
            },
            (error) => {
                this.loginAttempts += 1;
                this.loginForm.controls["password"].reset();
                let errorObject = JSON.parse(error._body);
                if (errorObject.error === "pending_account") {
                    swal({
                        title: "Pending Account",
                        text: errorObject.error_description,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    });
                } else if (errorObject.error === "invalid_credentials") {
                    swal({
                        title: "Account Credentials",
                        text: errorObject.error_description,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    });
                    } else {
                        this.errorMessage = errorObject.error_description;
                }
            }).add(c => {
                this.isProcessing = false;
                this.pService.done();
                this.handleProcessing.emit(false);
            });
    }

    public onHandleProcessing(isProcessing) {
        this.isProcessing = isProcessing;
    }

    public GetBanner(): void {

        this.commonDataService
        .GetBanner()
        .map(response => response.json())
        .subscribe(
            response => {
         let banner = response.result;
         this.bannerMessage = banner.message;
         this.IsbannerMessageActive = banner.enabled;

        },
        (error) => {
            let parsedErrors = JSON.parse(error._body);
            if (parsedErrors) {
                this.errorMessage = parsedErrors.message;
            }
        });

    }
}


// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts